import {Skuska} from './skuska';

export class SkuskyByDate {
  bude = false;
  datum: string;
  skusky: Skuska[] = [];

  constructor(s: Skuska) {
    this.datum = s.datumSk;
    this.skusky.push(s);
    this.bude = s.bude;
  }
}
